(function(global) {
  "use strict";

  function normalizeSelectedValuesByPosition(selectedValuesByPosition) {
    return selectedValuesByPosition || {};
  }

  function matchesSelectionPrefix(variant, selectedValuesByPosition, targetPosition) {
    for (var position = 1; position < targetPosition; position += 1) {
      var selectedValue = selectedValuesByPosition[position];

      if (selectedValue && variant["option" + position] !== selectedValue) {
        return false;
      }
    }

    return true;
  }

  function getOptionValueState(config) {
    var variants = config.variants || [];
    var selectedValuesByPosition = normalizeSelectedValuesByPosition(config.selectedValuesByPosition);
    var targetPosition = config.targetPosition;
    var targetValue = config.targetValue;
    var exists = false;
    var available = false;

    for (var index = 0; index < variants.length; index += 1) {
      var variant = variants[index];

      if (!matchesSelectionPrefix(variant, selectedValuesByPosition, targetPosition)) {
        continue;
      }

      if (variant["option" + targetPosition] !== targetValue) {
        continue;
      }

      exists = true;

      if (variant.available) {
        available = true;
        break;
      }
    }

    if (!exists) {
      return "impossible";
    }

    if (!available) {
      return "sold_out";
    }

    return "available";
  }

  function findMatchingVariant(variants, selectedValues) {
    var safeVariants = variants || [];
    var safeSelectedValues = selectedValues || [];

    for (var index = 0; index < safeVariants.length; index += 1) {
      var variant = safeVariants[index];
      var matches = true;

      for (var position = 0; position < safeSelectedValues.length; position += 1) {
        if (variant["option" + (position + 1)] !== safeSelectedValues[position]) {
          matches = false;
          break;
        }
      }

      if (matches) {
        return variant;
      }
    }

    return null;
  }

  function normalizeSelectedValues(config) {
    var variants = config.variants || [];
    var optionValuesByPosition = config.optionValuesByPosition || {};
    var selectedValuesByPosition = normalizeSelectedValuesByPosition(config.selectedValuesByPosition);
    var normalizedSelection = {};
    var positions = Object.keys(optionValuesByPosition).map(function(position) {
      return parseInt(position, 10);
    }).sort(function(left, right) {
      return left - right;
    });

    for (var index = 0; index < positions.length; index += 1) {
      var position = positions[index];
      var optionValues = optionValuesByPosition[position] || [];
      var preferredValue = selectedValuesByPosition[position];
      var preferredState = preferredValue ? getOptionValueState({
        variants: variants,
        selectedValuesByPosition: normalizedSelection,
        targetPosition: position,
        targetValue: preferredValue
      }) : "impossible";

      if (preferredState !== "impossible") {
        normalizedSelection[position] = preferredValue;
        continue;
      }

      for (var optionIndex = 0; optionIndex < optionValues.length; optionIndex += 1) {
        var optionValue = optionValues[optionIndex];
        var optionState = getOptionValueState({
          variants: variants,
          selectedValuesByPosition: normalizedSelection,
          targetPosition: position,
          targetValue: optionValue
        });

        if (optionState === "available") {
          normalizedSelection[position] = optionValue;
          break;
        }
      }

      if (normalizedSelection[position]) {
        continue;
      }

      for (var soldOutIndex = 0; soldOutIndex < optionValues.length; soldOutIndex += 1) {
        var soldOutValue = optionValues[soldOutIndex];
        var soldOutState = getOptionValueState({
          variants: variants,
          selectedValuesByPosition: normalizedSelection,
          targetPosition: position,
          targetValue: soldOutValue
        });

        if (soldOutState === "sold_out") {
          normalizedSelection[position] = soldOutValue;
          break;
        }
      }
    }

    return normalizedSelection;
  }

  global.BmVariantState = {
    findMatchingVariant: findMatchingVariant,
    getOptionValueState: getOptionValueState,
    normalizeSelectedValues: normalizeSelectedValues
  };
})(window);
